// extracted by mini-css-extract-plugin
export var actionText = "_m4-4";
export var container = "_m4-0";
export var leftSection = "_m4-1";
export var rightSection = "_m4-2";
export var settingsButton = "_m4-6";
export var settingsIcon = "_m4-7";
export var shortcut = "_m4-5";
export var shortcutGroup = "_m4-3";